import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteCohortsByDistrict } from '@/services/cohorts'

export function useDeleteCohortsByDistrict() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (districtId: string) => deleteCohortsByDistrict(districtId),
    onSuccess: (_, districtId) => {
      queryClient.invalidateQueries({ queryKey: ['cohorts', 'district', districtId] })
      queryClient.invalidateQueries({ queryKey: ['cohorts', 'nation'] })
    },
  })

  return {
    deleteCohortsByDistrict: mutation.mutate,
    deleteCohortsByDistrictAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    error: mutation.error,
  }
}
